import { render, staticRenderFns } from "./shopSort.vue?vue&type=template&id=a369fc5c&scoped=true&"
import script from "./shopSort.vue?vue&type=script&lang=js&"
export * from "./shopSort.vue?vue&type=script&lang=js&"
import style0 from "./shopSort.vue?vue&type=style&index=0&id=a369fc5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a369fc5c",
  null
  
)

export default component.exports